<template>
  <div class="buyer-description">
    <h3>{{ title }}</h3>
    <div v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: 'BuyerListingDetailsDescription',
  props: {
    title: String,
    content: String,
  }
}
</script>

<style scoped>
.buyer-description {
  position: relative;
  overflow: hidden;

  margin: 20px 0 20px;
  padding-top: 15px;
  padding-left: 15px;
}

.buyer-description::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;

  width: 5px;

  background-color: #F1563F;
  border-radius: 5px;
}

.buyer-description h3 {
  margin-bottom: 15px;

  color: #5F6062;
  font-family: 'SansationBold', sans-serif;
  font-size: 17px;
}

.buyer-description >>> p {
  color: #1E1B1B;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/buyer-description.vue